{
  "tab": {
    "countries": "Quốc gia",
    "regions": "Khu vực"
  },
  "button": {
    "viewAll": "Xem tất cả điểm đến",
    "checkSupport": "Kiểm tra thiết bị hỗ trợ",
    "standard": "Tiêu chuẩn",
    "dailyLimit": "Giới hạn ngày",
    "buy": "Mua",
    "continue": "Tiếp tục thanh toán",
    "loading": "Đang tải...",
    "stripe": "Thanh toán ngay",
    "backToHome": "Quay về trang chủ",
    "payNow": "Thanh toán ngay"
  },
  "nav": {
    "esimShop": "Cửa hàng eSIM"
  },
  "checkout": {
    "title": "Thanh toán bảo mật",
    "section": {
      "package": "Sơ lược đơn hàng"
    },
    "field": {
      "coverage": "Vùng phủ sóng",
      "traffic": "Dung lượng",
      "speed": "Tốc độ",
      "validity": "Hiệu lực",
      "days": "Ngày",
      "total": "Tổng cộng"
    },
    "payment": {
      "title": "Thanh toán",
      "orPayWith": "Thanh toán bằng PayPal",
      "secureEncrypted": "Thanh toán của bạn được bảo mật 100% và mã hóa"
    },
    "trust": {
      "instantDelivery": "Giao eSIM ngay lập tức qua email/mã QR sau khi thanh toán",
      "moneyBack": "Đảm bảo hoàn tiền trong 30 ngày – Hoạt động hoặc hoàn tiền",
      "support": "Hỗ trợ 24/7"
    }
  },
  "register": {
    "title": "Nhập Email của bạn",
    "breadcrumb": "Email của bạn"
  },
  "profile": {
    "esimTitle": "eSIM {index}",
    "scanToInstall": "Quét để cài đặt",
    "field": {
      "iccid": "ICCID",
      "activationCode": "Mã kích hoạt"
    },
    "action": {
      "copy": "Sao chép",
      "copied": "Đã sao chép!"
    }
  },
  "search": {
    "placeholder": "Bạn đang đi du lịch đến đâu?",
    "destinations": "Điểm đến",
    "results": "Kết quả",
    "resultsPlural": "Kết quả",
    "noResults": "Không tìm thấy điểm đến",
    "country": "Quốc gia",
    "region": "Khu vực",
    "esimPlan": "Tìm gói eSIM",
    "validation": {
      "selectCountryError": "Tìm kiếm quốc gia hoặc khu vực bạn sắp đến"
    }
  },
  "packages": {
    "deviceCompatibility": "Kiểm tra tương thích thiết bị",
    "topUp": "Nếu hết dung lượng, bạn có thể <strong>nạp thêm</strong> bất cứ lúc nào",
    "packageStartNote": "Gói cước bắt đầu khi bạn kết nối với mạng được hỗ trợ",
    "deviceRequirements": {
      "intro": "Để sử dụng eSIM, thiết bị của bạn phải đáp ứng các điều kiện sau:",
      "esimSupport": "Thiết bị hỗ trợ eSIM.",
      "notLocked": "Thiết bị không bị khóa mạng hoặc khóa nhà mạng."
    }
  }
}